export const DEFAULT_DELIMITER = ',';

/**
 * The number of items to render above and below the visible window for the virtualized list.
 */
export const SELECT_OVERSCAN_COUNT = 10;

/**
 * The default option height. This is used to get the estimated height of an option if its size can't be computed for the virtualized list.
 */
export const DEFAULT_OPTION_HEIGHT = 40;
